import { baseApi } from "./base.api";

const API_URL = import.meta.env.VITE_API_URL || "http://localhost:3000";

export const membershipService = {
  // Get current gym's membership status
  getStatus: async () => {
    const response = await baseApi.get(`/membership/status`);
    return response;
  },

  // Create or update membership (for admin/gym owner)
  createOrUpdate: async (data) => {
    const response = await baseApi.post(`/membership`, data);
    return response;
  },

  // Get membership by gym ID
  getByGymId: async (gymId) => {
    const response = await baseApi.get(`/membership/gym/${gymId}`);
    return response;
  },
};
